import { catalog } from "./data/catalog.js";
import createShareContainer from './modules/create-share-container.js';
import Filter from "./modules/filter.js";

const word = `son`;
const keys = Object.values(catalog[`стильный`]);
const divsWithCertainClassName = keys.filter(
  (it) => {
    let a = it.filter.indexOf(word);

    return it.filter.indexOf(word) >= 0;
  }
);


const siteBodyElement = document.querySelector(`.page__body`);

const filter = new Filter(siteBodyElement);
filter.init();


const shareContainerPopup = createShareContainer();
shareContainerPopup.classList.add('congrats__share');
shareContainerPopup.classList.add('share__list_present');
shareContainerPopup.classList.add('share__list');
const shareContainerFooter = createShareContainer();
shareContainerFooter.classList.add('share__list');
document.querySelector('.page__footer').append(shareContainerFooter);
// const  wheelFortune = new WheelFortune(siteBodyElement);
// wheelFortune.init();

// const congrats = new Congrats(siteBodyElement);
// congrats.init();
